import React from 'react'
import { motion, animate } from "motion/react"
import associated1 from '../../../assets/images/association/Picture1.jpg'
import associated2 from '../../../assets/images/association/Picture2.jpg'
import associated3 from '../../../assets/images/association/Picture3.jpg'
import associated4 from '../../../assets/images/association/Picture4.jpg'
import associated5 from '../../../assets/images/association/Picture5.jpg'
export default function AssociatedOrganizations() {
  const sectionReveal = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: 'easeOut' },
    viewport: { once: true, amount: 0.2 },
  }
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: 60, // from right
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 120,
        damping: 18,
      },
    },
  };

  return (
    <motion.section {...sectionReveal} className="mt-24 pb-24 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">

          {/* Header */}
          <div className="text-center mb-14">
            <p className="text-3xl font-semibold text-sky-700 mb-2">
              الجمعيات الخيرية المشاركة
            </p>
          </div>

          {/* Partners Grid */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            className="flex flex-wrap justify-center gap-6 sm:gap-10"
          >
            {[
              associated1,
              associated2,
              associated3,
              associated4,
              associated5
            ].map((logo, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                whileHover={{ y: -6, scale: 1.08 }}
                transition={{ type: "spring", stiffness: 220, damping: 18 }}
                className="group"
              >
                <div
                  className="
                    flex items-center justify-center
                    w-[240px] h-[140px]
                    bg-white/90 backdrop-blur
                    rounded-3xl
                    border border-slate-100
                    shadow-[0_20px_50px_-25px_rgba(15,23,42,0.35)]
                    transition-all duration-500
                    hover:border-sky-200
                    p-2
                  "
                >
                  <img
                    src={logo}
                    alt={`associated-${index + 1}`}
                    className="max-h-28 max-w-[100%] object-contain"
                  />
                </div>
              </motion.div>
            ))}
          </motion.div>

        </div>
      </motion.section>
  )
}
